var _rect, _rect2, _g, _path, _path2, _path3, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKenya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_528_1161)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#151515"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_528_1161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 0,
    width: 32,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -4,
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_528_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 0H28V24H-4V0Z",
    fill: "#0067C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 0V8H28V0H-4Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 16V24H28V16H-4Z",
    fill: "#4D8B1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 7.5H-4.5V8V16V16.5H-4H28H28.5V16V8V7.5H28H-4Z",
    fill: "#E31C1C",
    stroke: "#F5FBFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6234 4.03049C15.8518 3.61976 16.4658 3.17124 17.4653 2.68494C17.4997 2.66823 17.5412 2.66727 17.5765 2.68238C17.6362 2.70794 17.661 2.77114 17.6316 2.82341L7.27402 21.4516L6.73474 21.2209L15.8648 4.80027C15.4514 4.74119 15.3709 4.4846 15.6234 4.03049Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36553 4.03049C8.61802 4.4846 8.53755 4.74119 8.12411 4.80027L17.2542 21.2209L16.7149 21.4516L6.35738 2.82341C6.32792 2.77114 6.35273 2.70794 6.41248 2.68238C6.44778 2.66727 6.48926 2.66823 6.52361 2.68494C7.52319 3.17124 8.13716 3.61976 8.36553 4.03049Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.9474C13.1961 20.9474 18 17.1772 18 12.5263C18 7.87552 13.1961 4.10529 12 4.10529C10.8039 4.10529 6 7.87552 6 12.5263C6 17.1772 10.8039 20.9474 12 20.9474Z",
    fill: "#E31C1C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_528_1161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 12,
    height: 17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.9474C13.1961 20.9474 18 17.1772 18 12.5263C18 7.87552 13.1961 4.10529 12 4.10529C10.8039 4.10529 6 7.87552 6 12.5263C6 17.1772 10.8039 20.9474 12 20.9474Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_528_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.999975 19.8947C5.63917 19.8947 9.39997 16.5958 9.39997 12.5263C9.39997 8.45685 5.63917 5.1579 0.999975 5.1579C-3.63922 5.1579 -7.40002 8.45685 -7.40002 12.5263C-7.40002 16.5958 -3.63922 19.8947 0.999975 19.8947Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 19.8947C27.6392 19.8947 31.4 16.5958 31.4 12.5263C31.4 8.45685 27.6392 5.1579 23 5.1579C18.3608 5.1579 14.6 8.45685 14.6 12.5263C14.6 16.5958 18.3608 19.8947 23 19.8947Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.24 11.4C12.7878 11.0586 13.2 9.57186 13.2 7.78947C13.2 6.00708 12.7878 4.52031 12.24 4.17896V11.4ZM11.64 11.305C11.1532 10.8355 10.8 9.43913 10.8 7.78947C10.8 6.13981 11.1532 4.74339 11.64 4.27392V11.305ZM11.64 13.7476V20.7787C11.1532 20.3092 10.8 18.9128 10.8 17.2632C10.8 15.6135 11.1532 14.2171 11.64 13.7476ZM12.24 20.8737V13.6526C12.7878 13.994 13.2 15.4808 13.2 17.2632C13.2 19.0455 12.7878 20.5323 12.24 20.8737Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.4737C12.6628 11.4737 13.2 11.9449 13.2 12.5263C13.2 13.1076 12.6628 13.5789 12 13.5789C11.3373 13.5789 10.8 13.1076 10.8 12.5263C10.8 11.9449 11.3373 11.4737 12 11.4737Z",
    fill: "#F5FBFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_528_1161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/Kenya.dec58db8552e30a23126a89fce256b16.svg";
export { ForwardRef as ReactComponent };